import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'cwru-intro-text',
  styleUrl: 'intro-text.css',
  shadow: true,
})
export class IntroText {
  @Prop() heading: string;
  @Prop() href: string = "#";
  @Prop() linktext: string;
  @Prop() buttonwidth: string = "inline-s1";

  render() {
    return (
      <section class="container">
        <cwru-center andtext gutters="20px">
          <div class="content">
            <h2 class="heading">{this.heading}</h2>
            <slot></slot>
          </div>
          <cwru-button href={this.href} width={this.buttonwidth}>{this.linktext}</cwru-button>
        </cwru-center>
      </section>
    );
  }
}
